import { Component, OnInit } from '@angular/core';

@Component({
   // tslint:disable-next-line:component-selector
   selector: 'gm-loading-spinner',
   templateUrl: './loading-spinner.component.html',
   styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent { }
